import React from 'react'

const VisitorInfoEdit = () => {
  return (
    <div>VisitorInfoEdit</div>
  )
}

export default VisitorInfoEdit